<template>
  <div>

    <span>

      <div class="card">

        <div class="card-header">
          <div class="card-header-title">
            Show Conventional
          </div>
        </div>

        <div
          class="card-content"
          style="background-color: #FFFFDD"
        >
          <b-switch v-model="showConventional"></b-switch>
        </div>

      </div>

    </span>

    <span v-if="$store.state.evaluation.calculator.conventionalInputs.show">

      <div class="card">

        <div class="card-header">
          <div class="card-header-title">
            Conventional Loan
          </div>
        </div>

        <div
          class="card-content"
          style="background-color: #FFFFDD"
        >
          <b-field
            label="Down payment"
            custom-class="is-small"
          >
            <vue-autonumeric
              class="input"
              style="text-align: right"
              v-model="$store.state.evaluation.calculator.conventionalInputs.downPaymentPercent"
              :options="percentage"
            />
          </b-field>
          <b-field
            label="Loan term"
            custom-class="is-small"
          >
            <vue-autonumeric
              class="input"
              style="text-align: right"
              v-model="$store.state.evaluation.calculator.conventionalInputs.loanTermInYears"
              :options="years"
            />
          </b-field>
          <b-field
            label="Interest rate"
            custom-class="is-small"
          >
            <vue-autonumeric
              class="input"
              style="text-align: right"
              v-model="$store.state.evaluation.calculator.conventionalInputs.interestRatePercent"
              :options="percentage"
            />
          </b-field>
          <b-field
            label="Lender & title fees"
            custom-class="is-small"
          >
            <vue-autonumeric
              class="input"
              style="text-align: right"
              v-model="$store.state.evaluation.calculator.conventionalInputs.lenderAndTitleFees"
              :options="currency"
            />
          </b-field>
          <b-field
            label="# months tax & ins"
            custom-class="is-small"
          >
            <vue-autonumeric
              class="input"
              style="text-align: right"
              v-model="$store.state.evaluation.calculator.conventionalInputs.monthsTaxAndInsurance"
              :options="months"
            />
          </b-field>
          <b-field
            label="Mortgage ins. annually"
            custom-class="is-small"
          >
            <vue-autonumeric
              class="input"
              style="text-align: right"
              v-model="$store.state.evaluation.calculator.conventionalInputs.mortgageInsuranceAnnual"
              :options="currency"
            />
          </b-field>
          <button
            class="button is-primary"
            @click="updateCalc($store.state.evaluation)"
          >Update</button>
          <p>&nbsp;</p>
          <p v-if="warningList != ''">
            <b-message
              type="is-warning"
              has-icon
              size="is-small"
            >
              Please check:<br />{{ warningList }}
            </b-message>
          </p>
        </div>

      </div>

    </span>
  </div>
</template>

<script>
import store from "@/store";
import VueAutonumeric from "vue-autonumeric/src/components/VueAutonumeric.vue";

export default {
  components: {
    store,
    VueAutonumeric
  },

  data() {
    return {
      showConventional: this.$store.state.evaluation.calculator
        .conventionalInputs.show,
      warningList: "",
      number: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: "",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 0
      },
      currency: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: "$",
        currencySymbolPlacement: "p",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 0
      },
      percentage: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: "%",
        currencySymbolPlacement: "s",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 6,
        allowDecimalPadding: false
      },
      years: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: " years",
        currencySymbolPlacement: "s",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 6,
        allowDecimalPadding: false
      },
      months: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: " months",
        currencySymbolPlacement: "s",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 6,
        allowDecimalPadding: false
      }
    };
  },

  watch: {
    showConventional() {
      this.$store.state.evaluation.calculator.conventionalInputs.show = this.showConventional;
      //   await this.$store.commit("SET_CONVENTIONAL_SHOW", this.showConventional);
      this.updateCalc(this.$store.state.evaluation);
    }
  },

  methods: {
    async updateCalc(evaluation) {
      await store.dispatch("updatePropertyEvaluationCalculator", evaluation);
      this.warningList = "";
      if (this.$store.state.evaluation.conventionalWarnings) {
        this.$store.state.evaluation.conventionalWarnings.forEach(element => {
          this.warningList += element + ", ";
        });
        this.warningList = this.warningList.slice(0, -2);
      }
    }
  }
};
</script>

<style>
.label {
  margin-top: 0.5em;
  margin-bottom: 0em !important;
}
</style>
